<template>
	<div>
		<v-row align="center" class="grey lighten-5">
	      <v-col class="text-center" cols="12" sm="3">
	        <div class="my-2">
	          <router-link :to="'/md5-hash'">
	            <v-btn small :outlined="md5Hash" color="primary" rounded dark>MD5 Hash</v-btn>
	          </router-link>
	        </div>
	      </v-col>
	      <v-col class="text-center" cols="12" sm="3">
	        <div class="my-2">
	          <router-link :to="'/sha1-hash'">
	            <v-btn small :outlined="sha1Hash" color="primary" rounded dark>SHA1 Hash</v-btn>
	          </router-link>
	        </div>
	      </v-col>
	      <v-col class="text-center" cols="12" sm="3">
	        <div class="my-2">
	          <router-link :to="'/sha256-hash'">
	            <v-btn small :outlined="sha256Hash" color="primary" rounded dark>SHA256 Hash</v-btn>
	          </router-link>
	        </div>
	      </v-col>
	      <v-col class="text-center" cols="12" sm="3">
	        <div class="my-2">
	          <router-link :to="'/sha512-hash'">
	            <v-btn small :outlined="sha512Hash" color="primary" rounded dark>SHA512 Hash</v-btn>
	          </router-link>
	        </div>
	      </v-col>
	    </v-row>
	</div>
</template>
<script>
	export default {
		props:{
			md5Hash: Boolean,
			sha1Hash: Boolean,
			sha256Hash: Boolean,
			sha512Hash: Boolean,
		}
	}
</script>